import { Theme } from "@mui/material/styles";

/** Pares de cores do theme para gradiente de cada carteirinha. */
const CARD_GRADIENT_PAIRS: [string, string][] = [
  ["primary700", "primary900"],
  ["secondary700", "secondary900"],
  ["success600", "success800"],
  ["secondary600", "secondary800"],
  ["primary600", "primary800"],
];

export function getHealthCardGradient(theme: Theme, index: number): string {
  const [fromKey, toKey] = CARD_GRADIENT_PAIRS[index % CARD_GRADIENT_PAIRS.length];
  const from =
    (theme.palette as Record<string, { main?: string }>)[fromKey]?.main ??
    theme.palette.primary.main;
  const to =
    (theme.palette as Record<string, { main?: string }>)[toKey]?.main ??
    theme.palette.primary.dark;
  return `linear-gradient(135deg, ${from} 0%, ${to} 100%)`;
}

/** Formata número da carteirinha em blocos (estilo cartão físico). */
export function formatInsuranceCardNumber(raw: string): string {
  const digits = raw.replace(/\D/g, "");
  if (!digits) return raw || "—";
  return digits.match(/.{1,4}/g)?.join(" ") ?? digits;
}

export function getInsurerInitials(name: string): string {
  return name
    .split(" ")
    .filter(Boolean)
    .map((word) => word[0])
    .join("")
    .substring(0, 2)
    .toUpperCase();
}
